export const ANON_GUARD_COOKIE = 'anonguard'
